module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-offset-5"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.enable_map_link
    }
  }, [_vm._v("Generar enlace")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7 col-md-offset-2"
  }, [(_vm.showLink) ? _c('a', {
    staticClass: "alert-link",
    attrs: {
      "href": _vm.mapLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.mapLink))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [(_vm.showLink) ? _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.mapLink),
      expression: "mapLink",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "btn btn-secondary btn-sm",
    attrs: {
      "type": "button",
      "data-toggle": "popover",
      "data-container": "body",
      "data-placement": "right",
      "data-content": "Copiado"
    }
  }, [_vm._v("Copiar")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header",
    attrs: {
      "data-background-color": "magenta"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('h4', {
    staticClass: "title"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-22667980!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/MapLink.vue
// module id = 242
// module chunks = 3